/**
 * @generated SignedSource<<d4bd7332657f5e9a5cc25dfb09c46ffd>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type issueStatus_nativeIssueTable_IssueStatusCell_isEditableInIssueView$data = {
  readonly id?: string;
  readonly " $fragmentType": "issueStatus_nativeIssueTable_IssueStatusCell_isEditableInIssueView";
};
export type issueStatus_nativeIssueTable_IssueStatusCell_isEditableInIssueView$key = {
  readonly " $data"?: issueStatus_nativeIssueTable_IssueStatusCell_isEditableInIssueView$data;
  readonly " $fragmentSpreads": FragmentRefs<"issueStatus_nativeIssueTable_IssueStatusCell_isEditableInIssueView">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isInlineEditingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "issueStatus_nativeIssueTable_IssueStatusCell_isEditableInIssueView",
  "selections": [
    {
      "condition": "isInlineEditingEnabled",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "id"
        }
      ]
    }
  ],
  "type": "JiraStatusField"
};

(node as any).hash = "90b4510b5676de561f64f2f42ad4418e";

export default node;
